// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "6c0279586fdad77e8dde888e44264dec57134261/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"41":"a0ec33ed","440":"486bdddc","581":"a474c96c","788":"2ee88f8e","804":"51a6e114","810":"5b7541cc"}[chunkId] + ".chunk.js";
};